import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

export const NoAuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const authState = inject(AuthState);

    // If user is authenticated, redirect to dashboard
    if (authState.isAuthenticated()) {
        router.navigate(['/main-dashboard']);
        return false;
    }

    // Not authenticated - allow access to sign-in page
    return true;
};